import { useState, useEffect } from 'react'
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import {getLocalStorage, setLocalStorage} from "./storage-helper";

export default function CookieBanner() {
    const [cookieConsent, setCookieConsent] = useState(false)

    useEffect(() => {
        const storedCookieConsent = getLocalStorage('cookie_consent', null)

        setCookieConsent(storedCookieConsent)
    }, [setCookieConsent])

    const handleConsent = (cookiesConsent) => {
        const consentedAnalytics = cookiesConsent.cookie.categories.some(
            (item) => item === 'analytics',
        )
        const newValue = consentedAnalytics ? 'granted' : 'denied'

        window.gtag('consent', 'update', {
            analytics_storage: newValue,
        })

        setLocalStorage('cookie_consent', consentedAnalytics)
    }

    useEffect(() => {
        CookieConsent.run({
            guiOptions: {
                consentModal: {
                    layout: 'bar',
                    position: 'bottom',
                    flipButtons: false,
                    equalWeightButtons: true,
                },
            },
            categories: {
                necessary: {
                    enabled: true, // this category is enabled by default
                    readOnly: true, // this category cannot be disabled
                },
                analytics: {
                    enabled: true,
                },
            },
            onConsent: (cookie) => {
                handleConsent(cookie)
            },
            onChange: (cookie) => {
                handleConsent(cookie)
            },

            hideFromBots: true,
            language: {
                default: 'en',
                translations: {
                    en: {
                        consentModal: {
                            title: 'We use cookies to improve your experience and for marketing.',
                            //description: 'Cookie modal description',
                            acceptAllBtn: 'Accept all',
                            //acceptNecessaryBtn: 'Reject all',
                            showPreferencesBtn: 'Manage Individual preferences',
                        },
                        preferencesModal: {
                            title: 'Manage cookie preferences',
                            acceptAllBtn: 'Accept all',
                            acceptNecessaryBtn: 'Reject all',
                            savePreferencesBtn: 'Accept current selection',
                            closeIconLabel: 'Close modal',
                            sections: [
                                {
                                    title: 'We use cookies to improve your experience and for marketing.',
                                    description:
                                        "Select below which cookies you'd like to opt-in or out of.",
                                },
                                {
                                    title: 'Strictly Necessary cookies',
                                    description:
                                        'These cookies are essential for the proper functioning of the website and cannot be disabled.',
                                    //this field will generate a toggle linked to the 'necessary' category
                                    linkedCategory: 'necessary',
                                },
                                {
                                    title: 'Performance and Analytics',
                                    description:
                                        'These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.',
                                    linkedCategory: 'analytics',
                                },
                                {
                                    title: 'More information',
                                    description:
                                        'For any queries in relation to my policy on cookies and your choices, please <a href="/contact">contact us</a>',
                                },
                            ],
                        },
                    },
                },
            },
        })
    }, [])

    return <></>
}
